import { isUndefinedOrNull } from 'util/checks'

export const isFiltroPreenchido = (texto: string | null | undefined): boolean => {
  return !isUndefinedOrNull(texto) && texto !== '||'
}

export const extractFromFiltro = (texto: string | null | undefined): string[] => {
  if (isUndefinedOrNull(texto) || texto === '||') return []
  return texto
    .replaceAll('|', ' ')
    .trim()
    .replaceAll(' ', ',')
    .split(',')
    .filter((s): s is string => !!s)
}
